<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-inline mb-3">
                    <div class="form-group">
                        <label for="search" class="sr-only">Search</label>
                        <input
                            type="text"
                            class="form-control"
                            name="search"
                            id="search"
                            placeholder="Search ..."
                            spellcheck="false"
                            v-model="filters.search"
                            @input="search"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-6 text-right">
                <a :href="`/performers/${performerId}/members/import`" class="btn btn-outline-primary">
                    <i class="fas fa-file-import mr-1"></i>
                    Import
                </a>
            </div>
        </div>

        <spinner v-if="loading" class="py-5"/>

        <table class="table table-bordered table-hover" v-if="!loading && members.length">
            <thead>
                <tr>
                    <th>Member nickname</th>
                    <th>Member name</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="member in members" :class="{'table-warning': member.change_status || member.deleting }">
                    <td>{{ member.nickname }}</td>
                    <td @dblclick="changeName(member)">
                        <input type="text"
                               class="form-control"
                               v-if="member.update_name"
                               v-model="member.name"
                               @keyup="updateNameOnKeyUp($event, member)"
                               @blur="updateName(member)">
                        <span v-else>
                            <i class="fas fa-pencil-alt text-muted mr-1"></i>
                            {{ member.name }}
                        </span>
                    </td>
                    <td class="text-center">
                        <badge variant="success" v-if="member.active && !member.change_status">Active</badge>
                        <badge variant="error" v-if="!member.active && !member.change_status">Inactive</badge>
                        <span v-if="member.change_status">Please wait ...</span>
                    </td>
                    <td class="text-center">
                        <button type="button"
                                v-if="member.active"
                                @click="changeStatus(member, false)"
                                class="btn btn-outline-danger btn-sm mr-1">
                            Deactivate
                        </button>
                        <button type="button"
                                v-if="!member.active"
                                @click="changeStatus(member, true)"
                                class="btn btn-outline-success btn-sm mr-1">
                            Activate
                        </button>
                        <button type="button"
                                @click="removeMember(member)"
                                class="btn btn-outline-danger btn-sm">
                            <i class="fas fa-trash mr-1"></i>
                            Remove
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <paginate
            v-if="!loading && total > 1 && members.length"
            :page-count="total"
            :click-handler="changePage"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
            :prev-text="'Prev'"
            :next-text="'Next'">
        </paginate>

        <h4
            class="text-center text-muted py-5 border m-0"
            v-if="!loading && !members.length"
        >No records.</h4>
    </div>
</template>

<script>
import SweetAlert from "./../SweetAlert";

export default {
    props: ['performer-id'],

    data() {
        return {
            members: [],
            loading: false,
            searching: false,
            total: 0,
            filters: {
                search: '',
                page: 1,
            }
        };
    },
    methods: {
        search: _.debounce(function () {
            this.searching = true;
            this.fetch(false);
        }, 500),
        changePage(pageNum) {
            this.filters.page = pageNum;
            this.fetch(false);
        },
        fetch(withLoader = true) {
            if (withLoader) {
                this.loading = true;
            }

            return axios.get(`/api/performers/${this.performerId}/members`, {
                params: this.filters
            }).then(response => {
                this.members = response.data.data;
                this.total = response.data.pagination.total_pages;
                this.filters.page = response.data.pagination.current_page;
                this.loading = false;
                this.searching = false;

                return response;
            }).catch(() => {
                this.loading = false;
                this.searching = false;
            });
        },
        removeMember(member) {
            SweetAlert.confirm().then(result => {
                if (result.isConfirmed) {
                    member.deleting = true;
                    axios.delete(`/api/performers/${this.performerId}/members/${member.id}`).then(() => {
                        this.fetch(false).then(() => {
                            SweetAlert.success({title: 'Member has been removed!'});
                            member.deleting = false;
                        }).catch(() => member.deleting = false);
                    }).catch(() => member.deleting = false);
                }
            });
        },
        changeStatus(member, active) {
            member.change_status = true;
            axios.put(`/api/performers/${this.performerId}/members/${member.id}/status`, {
                active: active
            }).then(() => {
                this.fetch(false).then(() => member.change_status = false);
            }).catch(() => member.change_status = false);
        },
        changeName(member) {
            member.update_name = true;
        },
        updateName(member) {
            axios.put(`/api/performers/${this.performerId}/members/${member.id}/name`, {
                name: member.name
            }).then(() => {
                this.fetch(false);
            });
        },
        updateNameOnKeyUp($event, member) {
            if ($event.keyCode === 13) {
                this.updateName(member);
            }
        }
    },

    mounted() {
        this.fetch();
    }
}
</script>
